import {
  FolderList,
  OtherProductDocumentsDetails,
  PostAddDocuments,
  ProductSaveFolderList,
} from '@/api/model/productModel'

export interface State {
  //商品格納先フォルダ一覧
  modalDetailFolderActived: boolean
  //保存の確認ダイアログ
  modalDetailFolderSubmitActived: boolean
  //削除の確認ダイアログ
  modalDetailFolderDeleteActived: boolean
  //キャンセルの確認ダイアログ
  modalDetailFolderCancelActived: boolean
  //格納するフォルダの指定
  modalDetailTreeActived: boolean
  //他の商品からドキュメント追加
  modalDetailOtherProductDocumentAddActived: boolean
  //他の商品からドキュメント追加 追加確認ダイアログ
  modalDetailOtherProductDocumentSubmitActived: boolean
  //商品格納先フォルダ一覧 商品に紐付けるフォルダ
  productSaveFolderList: ProductSaveFolderList
  //データ変化あるか比べ用
  originFolderList: FolderList[]
  //表示用
  displayFolderList: FolderList[]
  //表示データと比較用
  displayFolderListBackup: FolderList[]
  //変化したデータ
  changedFolderList: FolderList[]
  //商品格納先フォルダ一覧　apiを呼び出してデータ更新必要かのフラグ
  callApi: boolean
  //商品格納先フォルダ一覧　エラーメッセージ
  errorMessagesFolderList: string[]
  //格納するフォルダの指定　エラーメッセージ
  errorMessagesFolderAdd: string[]
  //削除するデータのフォルダID
  deleteFolderId: number
  //他の商品からドキュメント追加 追加するドキュメントデータ
  postAddDocuments: PostAddDocuments
  //他の商品からドキュメント追加 apiを呼び出してデータ更新必要かのフラグ
  callApiDocuments: boolean
  //他の商品からドキュメント追加 ドキュメントデータ
  otherProductDocuments: OtherProductDocumentsDetails[]
  csvUploadPage: boolean
  csvUploadPageStatus: number
  csvUploadPageNumber: number
  csvUploadGoodsName: string
  csvUploadGoodsList: any[]
  csvUploadFileName: string
  csvUploadFileList: any[]
  selectedFile: any
  modalDeleteProductActived: boolean
}

const state = (): State => ({
  //商品格納先フォルダ一覧
  modalDetailFolderActived: false,
  //保存の確認ダイアログ
  modalDetailFolderSubmitActived: false,
  //削除の確認ダイアログ
  modalDetailFolderDeleteActived: false,
  //キャンセルの確認ダイアログ
  modalDetailFolderCancelActived: false,
  //格納するフォルダの指定
  modalDetailTreeActived: false,
  //他の商品からドキュメント追加
  modalDetailOtherProductDocumentAddActived: false,
  //他の商品からドキュメント追加 追加確認ダイアログ
  modalDetailOtherProductDocumentSubmitActived: false,
  //商品格納先フォルダ一覧 商品に紐付けるフォルダ
  productSaveFolderList: [],
  //データ変化あるか比べ用
  originFolderList: [],
  //表示用
  displayFolderList: [],
  //表示データと比較用
  displayFolderListBackup: [],
  //変化したデータ
  changedFolderList: [],
  //商品格納先フォルダ一覧　apiを呼び出してデータ更新必要かのフラグ
  callApi: true,
  //商品格納先フォルダ一覧　エラーメッセージ
  errorMessagesFolderList: [],
  //格納するフォルダの指定　エラーメッセージ
  errorMessagesFolderAdd: [],
  //削除するデータのフォルダID
  deleteFolderId: -1,
  //他の商品からドキュメント追加 追加するドキュメントデータ
  postAddDocuments: {} as PostAddDocuments,
  //他の商品からドキュメント追加 apiを呼び出してデータ更新必要かのフラグ
  callApiDocuments: true,
  //他の商品からドキュメント追加 ドキュメントデータ
  otherProductDocuments: [],
  // CsvUploadModal show hide
  csvUploadPage: false,
  // 0 upload  1 table
  csvUploadPageStatus: 0,
  csvUploadPageNumber: 0,
  csvUploadGoodsName: '',
  csvUploadGoodsList: [],
  csvUploadFileName: '',
  csvUploadFileList: [],
  selectedFile: null,
  modalDeleteProductActived: false,
})

export default state
